const QuestionsAnswers = (QA = {}) => {
  const { questionsAnswers = [] } = QA;
  return (
    <div className="section__questions-answers">
      <h2>Most common questions</h2>
      {questionsAnswers.map((questionAnswer) => (
        <div className="section__questions-answers__single">
          <h5 className="section__questions-answers__heading">
            {questionAnswer.question}
          </h5>
          <p className="section__questions-answers__content">
           {questionAnswer.answer}
          </p>
        </div>
      ))}
    </div>
  );
};

export default QuestionsAnswers;

